import React, { Component } from "react";
import { connect } from "react-redux";
import { usersWatchOn, usersWatchOff } from "./actions/usersActions";
import {
  usersPublicWatchOn,
  usersPublicWatchOff,
  usersPublicUpdate
} from "./actions/usersPublicActions";
import _ from "lodash";

import { BrowserRouter as Router, Route } from "react-router-dom";

import Login from "./components/login";
import Nav from "./components/nav";
import Front from "./components/front";
import Quiz1 from "./components/quiz1";
import Quiz2 from "./components/quiz2";
import Quiz3 from "./components/quiz3";
import Quiz4 from "./components/quiz4";
import Quiz4Feedback from "./components/quiz4Feedback";
import EarlyVoting from "./components/debate-earlyVoting";
import UsersManager from "./components/usersManager";
import Awards from "./components/debate-awards";
import Feedback from "./components/debate-feedback";
import FinalVoting from "./components/debate-finalVoting";
import PrivacyPolicyAndroid from "./components/privacyPolicy/index_android";
import PrivacyPolicyIos from "./components/privacyPolicy/index_ios";

const MainTemplate = () => (
  <Router>
    <div className="col-2">
      <Nav />
    </div>

    <div className="col-10">
      {/* HOME */}
      <Route exact path="/" component={Front} />
      <Route path="/users-manager" component={UsersManager} />
      {/* QUIZ */}
      <Route path="/quiz1" component={Quiz1} />
      <Route path="/quiz2" component={Quiz2} />
      <Route path="/quiz3" component={Quiz3} />
      <Route path="/quiz4" component={Quiz4} />
      <Route path="/quiz4-feedback" component={Quiz4Feedback} />
      {/* DEBATE */}
      <Route path="/early-voting" component={EarlyVoting} />
      <Route path="/awards" component={Awards} />
      <Route path="/feedback" component={Feedback} />
      <Route path="/final-voting" component={FinalVoting} />
      <Route path="/privacy-policy" component={PrivacyPolicyIos} />
      <Route path="/privacy-policy-android" component={PrivacyPolicyAndroid} />
    </div>
  </Router>
);

const LoginPage = () => (
  <Router>
    <div className="col-12">
      {/* PRIVACY POLICY */}
      <Route path="/privacy-policy" component={PrivacyPolicyIos} />
      <Route path="/privacy-policy-android" component={PrivacyPolicyAndroid} />
      {/* <Login /> */}
      <Route path="/" component={Login} />
    </div>
  </Router>
);

class App extends Component {
  componentDidUpdate(prevProps, prevState) {
    const { user: prevUser } = prevProps.auth || {};
    const { user: currUser } = this.props.auth || {};

    const { users: prevUsers } = prevProps.props || {};
    const { users: currUsers } = this.props || {};

    const { usersPublic } = this.props || {};

    if (prevUser !== currUser) {
      this.toggleUsersWatch(currUser);
    }

    /** update users public data */
    if (!_.isEmpty(currUsers) && prevUsers !== currUsers) {
      this.updateUsersPublicData(currUsers, usersPublic);
    }
  }

  updateUsersPublicData = (users, usersPublic) => {
    /** necessary for debate feedback, awards to provide class members uid name matches */
    const newUsersPublic = Object.entries(users).map(([uid, user]) => ({
      uid,
      cClass: user.currentClass,
      name: user.name
    }));

    if (usersPublic !== null && !_.isEqual(usersPublic, newUsersPublic)) {
      this.props.usersPublicUpdate(newUsersPublic);
    }
  };

  toggleUsersWatch(user) {
    if (_.isEmpty(user) || !user) {
      this.props.usersWatchOff();
      this.props.usersPublicWatchOff();
    } else {
      this.props.usersWatchOn();
      this.props.usersPublicWatchOn();
    }
  }

  render() {
    const { uid } = this.props.auth.user || {};
    return (
      <div className="App container-fluid py-5">
        <div className="row">{uid ? <MainTemplate /> : <LoginPage />}</div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  users: state.users,
  usersPublic: state.usersPublic
});

export default connect(
  mapStateToProps,
  {
    usersWatchOn,
    usersWatchOff,
    usersPublicWatchOn,
    usersPublicWatchOff,
    usersPublicUpdate
  }
)(App);
